require('angular')
require('../flash/flash-module')
require('../../../core/translation/translation-module')

UnexpectedErrorHandlerInterceptor = require('./unexpected-error-handler-interceptor')

modules = [
  'gnp-flash',
  'gnp-translation'
]
angular.module 'gnp-error-handler', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .config ['$httpProvider', ($httpProvider) ->
    $httpProvider.interceptors.push('UnexpectedErrorHandlerInterceptor')
  ]
  .factory 'UnexpectedErrorHandlerInterceptor', UnexpectedErrorHandlerInterceptor
  .run UnexpectedErrorHandlerInterceptor




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/error-handler/error-handler-module.coffee